import {callAPI} from '@/store/utils';
import en from '@/data/tracking/index.js'; // eslint-disable-line

const FYGR_COMPANY = 'FYGR_COMPANY';

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async actionUpdateHubSpotObject(_, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'updateHubSpotObject', {
        ...params,
        companyId,
      });
      return res;
    },
    async actionSendUserDeviceInfo(_, params) {
      function getBrowserInfo() {
        const userAgent = navigator.userAgent;

        if (userAgent.includes('Chrome')) {
          return {
            browser: 'Chrome',
            version: userAgent.match(/Chrome\/(\d+)/)?.[1],
          };
        } else if (userAgent.includes('Firefox')) {
          return {
            browser: 'Firefox',
            version: userAgent.match(/Firefox\/(\d+)/)?.[1],
          };
        } else if (
          userAgent.includes('Safari') &&
          !userAgent.includes('Chrome')
        ) {
          return {
            browser: 'Safari',
            version: userAgent.match(/Version\/(\d+)/)?.[1],
          };
        } else if (userAgent.includes('Edge')) {
          return {browser: 'Edge', version: userAgent.match(/Edg\/(\d+)/)?.[1]};
        } else {
          return {browser: 'Unknown', version: 'Unknown'};
        }
      }

      function getOperatingSystem() {
        const userAgent = navigator.userAgent;

        if (userAgent.includes('Windows')) return 'Windows';
        if (userAgent.includes('Macintosh')) return 'MacOS';
        if (userAgent.includes('Linux')) return 'Linux';
        if (userAgent.includes('Android')) return 'Android';
        if (userAgent.includes('iPhone') || userAgent.includes('iPad'))
          return 'iOS';

        return 'Unknown';
      }

      function getDeviceType() {
        const userAgent = navigator.userAgent;

        if (/Mobi|Android/i.test(userAgent)) return 'Mobile';
        if (/Tablet|iPad/i.test(userAgent)) return 'Tablet';
        return 'Desktop';
      }

      const browserInfo = getBrowserInfo();
      const os = getOperatingSystem();
      const deviceType = getDeviceType();

      window.analytics.track(en.EN_USER_SESSION_STARTED.name, {
        ...en.EN_USER_SESSION_STARTED.properties,
        browser: browserInfo.browser,
        browserVersion: browserInfo.version,
        operatingSystem: os,
        deviceType: deviceType,
        devicePixelRatio: window.devicePixelRatio || 1,
        innerWidth: window.innerWidth || null,
        innerHeight: window.innerHeight || null,
        outerWidth: window.outerWidth || null,
        outerHeight: window.outerHeight || null,
      });
    },
  },
};
